import React, { Component } from 'react';
import { Button, Col, Form, Modal } from 'react-bootstrap';

import './CategoryChange.css';

class AssetChange extends Component {

    constructor(props) {
        super(props);
        this.state = { errMsg: '' };
    }

    //colours are stored as 6 hex digits without '#' (see AssetItemList swatch rendering);
    //the native picker works in '#rrggbb', so convert in both directions
    handlePickColour = (e) => {
        this.props.handleUpdateColourChange({ target: { value: e.target.value.replace('#', '') } });
    }

    pickerColour = () => {
        const colour = this.props.asset.colour;
        return /^[0-9a-fA-F]{6}$/.test(colour) ? '#' + colour : '#000000';
    }

    handleUpdateAsset = (e) => {
        e.preventDefault();
        e.stopPropagation();

        fetch('asset_update', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: "assetId=" + this.props.asset.assetId +
                  "&asset=" + this.props.asset.asset +
                  "&colour=" + this.props.asset.colour
        })
        .then(res => res.json())
        .then(data => {
            if ('true' === data[0].update) {
                this.setState({ errMsg: '' });
                this.props.hideUpdateAsset();
            }
            else {
                this.setState({ errMsg: data[0].msg });
            }
        })
        .catch(console.log)
    }

    render() {
        return (
            <Modal
              show={this.props.updateAssetVisible}
              onHide={this.props.hideUpdateAsset}
              backdrop="static"
              centered
            >
            <Modal.Header closeButton>
                <Modal.Title><center><h1 class="pageTitle">Update {this.props.assetTitle || 'Asset'}</h1></center></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                <Form className="ProcessAddForm" onSubmit={this.handleSubmit}>
                    <Form.Row>
                        <Form.Group as={Col} controlId="frmAsset">
                            <Form.Label class="CategoryAddLabel">Asset</Form.Label>
                            <Form.Control className="CategoryAddControl" type="text" placeholder="asset" value={this.props.asset.asset} onChange={this.props.handleUpdateAssetChange}/>
                        </Form.Group>

                        <Form.Group as={Col} controlId="frmColour">
                            <Form.Label class="CategoryAddLabel">Colour</Form.Label>
                            <div style={{ display: 'flex' }}>
                                <Form.Control className="CategoryAddControl" type="text" placeholder="colour" value={this.props.asset.colour} onChange={this.props.handleUpdateColourChange}/>
                                <input
                                    type="color"
                                    title="Pick a colour"
                                    value={this.pickerColour()}
                                    onChange={this.handlePickColour}
                                    style={{ width: '3rem', marginLeft: '0.5rem', padding: '0', border: '1px solid #282c34', borderRadius: '0.25rem', cursor: 'pointer', alignSelf: 'stretch' }}
                                />
                            </div>
                        </Form.Group>
                    </Form.Row>
                </Form>
            </div>
            </Modal.Body>
            <Modal.Footer>
                <span className="userAddErr">{this.state.errMsg}</span>
                <Button onClick={this.handleUpdateAsset}>Update</Button>
                <Button onClick={this.props.hideUpdateAsset}>Close</Button>
            </Modal.Footer>
            </Modal>
        )
    }
}

export default AssetChange;
